/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type Languages = typeof Languages[keyof typeof Languages];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Languages = {
  EN: 'EN',
  SW: 'SW',
} as const;
